import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About Me', path: '/about' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Events', path: '/events' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav style={{
      backgroundColor: 'var(--color-white)',
      borderBottom: '1px solid var(--color-gray-200)',
      position: 'sticky',
      top: 0,
      zIndex: 50,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    }}>
      <div className="container-artworld">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '80px'
        }}>
          {/* Logo */}
          <Link to="/" style={{ textDecoration: 'none' }}>
            <div>
              <h1 className="artist-name" style={{ margin: 0, lineHeight: '1.2' }}>Saloni Sharma</h1>
              <p style={{ 
                margin: 0, 
                fontSize: '0.65rem', 
                color: 'var(--color-gray-500)',
                fontFamily: 'Inter, sans-serif',
                fontWeight: '400',
                letterSpacing: '0.02em'
              }}>
                (She/Her)
              </p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div style={{
            display: 'none',
            gap: 'var(--spacing-xl)',
            alignItems: 'center'
          }} className="desktop-nav">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="nav-link"
                style={{
                  textDecoration: 'none',
                  color: isActive(item.path) ? 'var(--color-primary)' : 'var(--color-gray-700)',
                  fontWeight: isActive(item.path) ? '600' : '500',
                  position: 'relative'
                }}
              >
                {item.name}
                {isActive(item.path) && (
                  <div style={{
                    position: 'absolute',
                    bottom: '-4px',
                    left: 0,
                    right: 0,
                    height: '2px',
                    backgroundColor: 'var(--color-primary)'
                  }} />
                )}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            style={{
              display: 'block',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '8px'
            }}
            className="mobile-menu-btn"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div style={{
          borderTop: '1px solid var(--color-gray-200)',
          backgroundColor: 'var(--color-white)',
          padding: 'var(--spacing-md) 0'
        }} className="mobile-nav">
          <div className="container-artworld">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="nav-link"
                onClick={() => setIsOpen(false)}
                style={{
                  display: 'block',
                  textDecoration: 'none',
                  padding: 'var(--spacing-sm) 0',
                  color: isActive(item.path) ? 'var(--color-primary)' : 'var(--color-gray-700)',
                  fontWeight: isActive(item.path) ? '600' : '500'
                }}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}

      <style>{`
        @media (min-width: 768px) {
          .desktop-nav {
            display: flex !important;
          }
          .mobile-menu-btn {
            display: none !important;
          }
        }
        
        @media (max-width: 767px) {
          .mobile-nav {
            display: block;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
